// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const BreadcrumbContract = contract({
  name: "Breadcrumb",
  description: "Reach for Breadcrumb whenever a screen sits inside a hierarchy and you want the path back to the top to be visible. Common spots: above page titles in admin/CMS screens, top of Settings detail pages, after a router redirect when the URL implies depth. Use the current page as a <BreadcrumbPage> (non-clickable) and prior levels as <BreadcrumbLink>. For a horizontal \"top nav\" of peer destinations use Side Menu or Tabs instead — Breadcrumb is strictly for hierarchical path.",
  import: "@gradeui/ui",
  aliases: ["breadcrumb","breadcrumbs","crumbs","path","page hierarchy","path bar","navigation trail","finder path"],
  subcomponents: ["BreadcrumbList","BreadcrumbItem","BreadcrumbLink","BreadcrumbPage","BreadcrumbSeparator","BreadcrumbEllipsis"],
  composesWith: ["AppShellMain","Card (in CardHeader)","Dialog"],
  styleDefaults: {"BreadcrumbList":"flex flex-wrap items-center gap-1.5 break-words text-xs text-muted-foreground","BreadcrumbItem":"inline-flex items-center gap-1.5","BreadcrumbPage":"inline-flex items-center gap-1.5 px-0.5 text-xs font-medium text-foreground","BreadcrumbSeparator":"inline-flex items-center [&_svg]:size-3 [&_svg]:shrink-0 text-muted-foreground/60","BreadcrumbEllipsis":"flex h-5 w-5 items-center justify-center","BreadcrumbMenuTrigger":"h-3 w-3 text-muted-foreground transition-transform"},
  props: {
  "aria-label": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "passed to the underlying <nav>",
  },
  "separator": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "**tree-wide default** for every <BreadcrumbSeparator/> inside. Pass a string (\"/\", \"›\", \"•\"), a lucide icon (`<Slash/>`, `<ChevronRight/>`), or any ReactNode. Default: `<ChevronRight/>`. Set once on the root; every separator below picks it up via context.",
  },
  "className": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "the <ol> wrapper; usually no overrides needed",
  },
  "href": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "renders as <a> when set, <button> when not",
  },
  "asChild": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "children": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "per-instance override of the separator glyph. When set, beats the root's `separator` prop for this one slot. When not set, falls back to the root's `separator`, then to `<ChevronRight/>`.",
  },
  },
});
